import React from 'react'
import FlatButton from '../../../buttons/textButton/FlatButton';

const UndoToastButton = props => (
  <FlatButton accent clicked={props.action}>Undo</FlatButton>
)
export default UndoToastButton